import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/components/layout";
// import PcUserLayout from "@/views/user/layout/index.vue";

export const constantRoutes = [
  {
    path: "/404",
    component: () => import("@/views/404")
  },
  // pc
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    children: [
      // 登录注册
      // {
      //   path: "/login",
      //   name: "login",
      //   meta: { title: "登录/注册" },
      //   component: () => import("@/views/login")
      // },
      // 用户中心
      // {
      //   path: "/user",
      //   name: "user",
      //   // component: PcUserLayout,
      //   meta: { title: "个人中心" },
      //   redirect: "/",
      //   children: [
      //     // {
      //     //   path: "/user/wallet",
      //     //   name: "wallet",
      //     //   meta: { title: "我的钱包", needLogin: true },
      //     //   component: () => import("@/views/user/wallet")
      //     // }
      //     // {
      //     //   path: "/user/meterial",
      //     //   name: "meterial",
      //     //   meta: { title: "我的资料", needLogin: true },
      //     //   component: () => import("@/views/user/meterial")
      //     // }
      //   ]
      // },
      // {
      //   path: "/settle",
      //   name: "settle",
      //   meta: { title: "商家入驻" },
      //   component: () => import("@/views/settle")
      // },
      {
        path: "/contact",
        name: "contact",
        meta: { title: "Contact Us" },
        component: () => import("@/views/contact")
      },
      {
        path: "/about",
        name: "about",
        meta: { title: "About us" },
        component: () => import("@/views/about")
      },
      // {
      //   path: "/product",
      //   name: "product",
      //   meta: { title: "软件产品" },
      //   component: () => import("@/views/product")
      // },
      // 首页
      {
        path: "/home",
        name: "home",
        meta: { title: "Home" },
        component: () => import("@/views/home")
      }
    ]
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true
  }
];

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js